export default __webpack_public_path__ + "static/media/available_status_bar.afd23fa1.svg";